// extracted by mini-css-extract-plugin
export default {"wrapper":"Contacts_wrapper__3N6hM","menu":"Contacts_menu__o-zeF","icon":"Contacts_icon__1X5YW"};